module.exports = __webpack_public_path__ + "img/intro10.aea566ee.gif";